import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { createComponent as cc } from 'react-fela';
import { PAGES, COLORS } from '../util/constants';

import { SocialLinks } from './';

import animatedLogo from '../assets/S.gif';
import logo from '../assets/logo.svg';
import hdimg1 from '../assets/s_bg1.jpg';
import hdimg2 from '../assets/s_bg2.jpg';
import hdimg3 from '../assets/s_bg3.jpg';

const PicturePageWrapper = cc(_ => ({
  width: '100%',
  height: '100%',
  overflow: 'hidden',
}));

const SocialLinksWrapper = cc(_ => ({
  width: '100%',
  height: '10vh',
  textAlign: 'center',
  position: 'sticky',
}));

const FixedLogo = cc(({ logo }) => ({
  backgroundImage: `url(${logo})`,
  backgroundSize: '185px',
  backgroundColor: 'transparent',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  width: '100%',
  height: '100%',
  position: 'fixed',
  zIndex: '-1',
}));

const SignMeUpLabel = cc(
  ({ color }) => ({
    width: '100%',
    height: '10vh',
    position: 'fixed',
    zIndex: '5',
    textTransform: 'uppercase',
    textAlign: 'center',
    top: '4vh',
    color: color,
    fontWeight: '300',
    fontSize: '12px',
    cursor: 'pointer',
    ':hover': {
      color: COLORS.GOLD,
    },
  }),
  'a',
  ['onClick']
);

const AnimatedLogo = cc(({ logo, move }) => ({
  backgroundImage: `url(${logo})`,
  backgroundSize: '600px 600px',
  backgroundColor: 'transparent',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundAttachment: 'fixed',
  width: '600px',
  height: '600px',
  position: 'absolute',
  top: '150px',
  left: 'calc(50vw - 300px)',
  right: 'calc(50vw - 300px)',
  transition: 'top .3s',
}));

const FullscreenImage = cc(({ imageUrl, moveDown, position }) => ({
  backgroundImage: `url(${imageUrl})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  width: '100%',
  height: '120%',
  top: moveDown ? '0' : '-15%',
  transition: 'top 8s',
  position: 'absolute',
  zIndex: '-2',
  small: {
    backgroundPosition: position ? position : 'center',
  },
}));

const FullscreenOverlay = cc(({ logo, move }) => ({
  backgroundImage: `url(${logo})`,
  backgroundSize: '150px',
  backgroundColor: 'white',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundAttachment: 'fixed',
  position: 'fixed',
  right: '0',
  bottom: '0',
  left: '0',
  top: move ? '100%' : '0',
  zIndex: '1',
  transition: 'top 1s',
}));

const FullscreenOverlayTop = cc(({ logo, moveFromTop, moveToBottom }) => ({
  backgroundImage: `url(${logo})`,
  backgroundSize: '150px',
  backgroundColor: 'white',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundAttachment: 'fixed',
  position: 'fixed',
  right: '0',
  top: moveToBottom ? '100%' : '0',
  left: '0',
  bottom: !moveFromTop ? '100%' : '0',
  zIndex: '4',
  transition: 'bottom 1s, top 1s',
}));

class PicturePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stage: 0,
      overlaySecond: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ stage: 1 });
    }, 1200);
    setTimeout(() => {
      this.setState({ stage: 2 });
    }, 2200);
    setTimeout(() => {
      this.setState({ stage: 3 });
    }, 5200);
    setTimeout(() => {
      this.setState({ stage: 4 });
    }, 6200);
    setTimeout(() => {
      this.setState({ stage: 5 });
    }, 7200);
    setTimeout(() => {
      this.setState({ stage: 6 });
    }, 10200);
    setTimeout(() => {
      this.setState({ stage: 7 });
    }, 11200);
    setTimeout(() => {
      this.setState({ stage: 8 });
    }, 12200);
    setTimeout(() => {
      this.setState({ stage: 9 });
    }, 13200);
    setTimeout(() => {
      this.props.finished(PAGES.PICTURE_PAGE);
    }, 18200);
  }

  render() {
    const { stage, logoSwitch } = this.state;

    return (
      <PicturePageWrapper>
        {stage < 3 && (
          <div>
            <FullscreenOverlay
              move={ stage >= 2 }
              logo={ animatedLogo }
              className={ 'compactIn' }>
              <SocialLinksWrapper>
                <SocialLinks />
              </SocialLinksWrapper>
            </FullscreenOverlay>
          </div>
        )}
        {stage < 4 && (
          <div>
            <FixedLogo logo={ logo } />
            <FullscreenImage imageUrl={ hdimg3 } moveDown={ stage >= 1 } />
            {stage >= 1 &&
              stage < 3 && (
                <SignMeUpLabel
                  onClick={ () => this.props.finished(PAGES.PICTURE_PAGE) }
                  color={ 'white' }>
                  Sign me up
                </SignMeUpLabel>
              )}
          </div>
        )}
        {stage >= 2 && (
          <div>
            <FullscreenOverlayTop
              moveFromTop={ stage >= 3 }
              moveToBottom={ stage >= 5 }
              logo={ animatedLogo }>
              {stage >= 3 &&
                stage < 5 && (
                  <SignMeUpLabel
                    onClick={ () => this.props.finished(PAGES.PICTURE_PAGE) }
                    color={ 'black' }>
                    Sign me up
                  </SignMeUpLabel>
                )}
              {stage >= 3 &&
                stage <= 4 && (
                  <SocialLinksWrapper className={ 'fadeIn' }>
                    <SocialLinks />
                  </SocialLinksWrapper>
                )}
            </FullscreenOverlayTop>
          </div>
        )}
        {stage >= 4 && (
          <div>
            {stage >= 5 &&
              stage < 7 && (
                <SignMeUpLabel
                  onClick={ () => this.props.finished(PAGES.PICTURE_PAGE) }
                  color={ 'white' }>
                  Sign me up
                </SignMeUpLabel>
              )}
            <FixedLogo logo={ logo } />
            <FullscreenImage
              imageUrl={ hdimg2 }
              moveDown={ stage >= 5 }
              position={ '-150px center' } />
          </div>
        )}
        {stage >= 6 && (
          <div>
            <FullscreenOverlayTop
              moveFromTop={ stage >= 7 }
              moveToBottom={ stage >= 9 }
              logo={ animatedLogo }>
              {stage >= 7 && (
                <SignMeUpLabel
                  onClick={ () => this.props.finished(PAGES.PICTURE_PAGE) }
                  color={ 'black' }>
                  Sign me up
                </SignMeUpLabel>
              )}
              {stage >= 7 &&
                stage <= 8 && (
                  <SocialLinksWrapper className={ 'fadeIn' }>
                    <SocialLinks />
                  </SocialLinksWrapper>
                )}
            </FullscreenOverlayTop>
          </div>
        )}
        {stage >= 8 && (
          <div>
            {stage >= 9 && (
              <SignMeUpLabel
                onClick={ () => this.props.finished(PAGES.PICTURE_PAGE) }
                color={ 'white' }>
                Sign me up
              </SignMeUpLabel>
            )}
            <FixedLogo logo={ logo } />
            <FullscreenImage imageUrl={ hdimg1 } moveDown={ stage >= 9 } />
          </div>
        )}
      </PicturePageWrapper>
    );
  }
}

export default PicturePage;



// WEBPACK FOOTER //
// ./src/components/PicturePage.js